import { useState, useEffect } from 'react';
import { KEYWORD_INPUT_ID, SEARCH_AREA_INPUT_ID } from '../../constants';
import { useSearchContext } from '../../context/Search';

const useSearchResultsLogic = () => {
  const {
    focusedInput: [focusedInput],
  } = useSearchContext();
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [showSearchAreaSuggestions, setShowSearchAreaSuggestions] = useState(
    false
  );
  const [showKeywordSuggestions, setShowKeywordSuggestions] = useState(false);

  useEffect(() => {
    setShowSuggestions(!!focusedInput);
    if (focusedInput === SEARCH_AREA_INPUT_ID) {
      setShowSearchAreaSuggestions(true);
      setShowKeywordSuggestions(false);
    } else if (focusedInput === KEYWORD_INPUT_ID) {
      setShowSearchAreaSuggestions(false);
      setShowKeywordSuggestions(true);
    } else {
      setShowSearchAreaSuggestions(false);
      setShowKeywordSuggestions(false);
    }
  }, [focusedInput]);

  return {
    showKeywordSuggestions,
    showSearchAreaSuggestions,
    showSuggestions,
  };
};

export default useSearchResultsLogic;
